<template>
  <div class="container">
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div v-if="!fetchData">

      <b-modal id="cancelDeleteWkConfirmationModel" hide-header-close hide-footer hide-header centered size="sm">
        <h6 style="font-size: 18px; font-weight: 600" class="text-danger">
          Are you sure you want to proceed
        </h6>
        <div>
          <b-form-group id="input-group-1" label-for="input-1">
            <label class="required-label" for="">Enter a brief explanation of the reason for cancellation of
              deletion (Minimum 10 character):</label>
            <b-form-input id="input-1" v-model="deleteWkModel.reason" type="text"
              placeholder="Enter Reason"></b-form-input>
          </b-form-group>
        </div>
        <div class="buttons">
          <b-button :disabled="(deleteWkModel.reason.length < 10)" size="sm" variant="primary"
            @click="CancelDeletion()">Cancel Deletion</b-button>
          <b-button size="sm" variant="danger" class="ml-2"
            @click="$bvModal.hide('cancelDeleteWkConfirmationModel')">Cancel</b-button>
        </div>
      </b-modal>

      <b-modal id="deleteWkConfirmationModel" hide-header-close hide-footer hide-header centered size="sm">
        <h6 style="font-size: 18px; font-weight: 600" class="text-danger">
          Are you sure you want to delete {{ deleteWkModel.name }}
        </h6>
        <div :class="['disable-wrapper', { disabled: showOtpBox }]">
          <div>
            <b-form-group id="input-group-1" label-for="input-1">
              <label class="required-label" for="">Type 'DELETE' and press delete button to complete deletion:</label>
              <b-form-input id="input-1" v-model="deleteWkModel.confirmText" type="text" placeholder="Enter  DELETE"
                :class="['disable-wrapper', { disabled: showOtpBox }]"></b-form-input>
            </b-form-group>
          </div>
          <div>
            <b-form-group id="input-group-1" label-for="input-1">
              <label class="required-label" for="">Enter a brief explanation of the reason for deletion (Minimum 10
                character):</label>
              <b-form-input id="input-1" v-model="deleteWkModel.reason" type="text" placeholder="Enter Reason"
                :class="['disable-wrapper', { disabled: showOtpBox }]"></b-form-input>
            </b-form-group>
          </div>
          <div class="buttons">
            <b-button :disabled="(deleteWkModel.confirmText != 'DELETE' || deleteWkModel.reason.length < 10)" size="sm"
              variant="primary" @click="sendOtp()">Delete</b-button>
            <b-button size="sm" variant="danger" class="ml-2"
              @click="$bvModal.hide('deleteWkConfirmationModel'); otp = null; showOtpBox = false;">Cancel</b-button>
          </div>
        </div>
        <div v-if="showOtpBox" class="mt-3">
          <b-form-group>
            <label class="required-label">Enter OTP to confirm deletion:</label>
            <b-form-input v-model="otp" placeholder="Enter OTP"></b-form-input>
          </b-form-group>

          <p class="text-danger small">Please contact ezygo support for OTP</p>

          <div class="d-flex align-items-center mt-2">
            <b-button variant="success" size="sm" @click="verifyOtp()">
              Verify OTP & DELETE
            </b-button>

            <b-button size="sm" variant="danger" class="ml-2"
              @click="$bvModal.hide('deleteWkConfirmationModel'); otp = null; showOtpBox = false;">
              Cancel
            </b-button>
          </div>


        </div>

      </b-modal>

      <b-row class="control-buttons">
        <b-col v-if="resourceaction == 'list' && !course_id" style="text-align:left;">
          <b-button variant="success" class="text-white sm" size="sm" @click="createEditWk(null)">Add
            WK</b-button>
          <!-- <b-button variant="success" class="ml-2 text-white sm" size="sm" @click="downloadPdf()">Download
            PDF</b-button> -->
        </b-col>
        <b-col v-if="(resourceaction == 'createEdit' && wk.id == null && !enableImport && !enableWkCopy)"
          style="text-align:left;">
          <b-row>
            <b-button variant="success" class="mr-2 text-white sm" size="sm" @click="(enableImport = true)">Import
              Excel</b-button>
            <b-button variant="success" class="mr-2 text-white sm" size="sm" @click="getCopyWkOptions">Copy
              From Other Programmes </b-button>
          </b-row>
        </b-col>
        <b-col v-if="resourceaction != 'list'" style="text-align:right;">
          <b-button
            variant="success"
            class="text-white sm mr-2"
            size="sm"
            @click="createUpdateWk"
            :disabled="actionButton.disabled"
          >
            {{ actionButton.text }}
          </b-button>

          <b-button
            variant="danger"
            class="text-white sm"
            size="sm"
            @click="resourceaction = 'list'"
            :disabled="actionButton.disabled"
          >
            Cancel
          </b-button>
        </b-col>

      </b-row>
      <div v-if="resourceaction == 'list'">
        <h3 style="text-align: center; font-size:18px !important;">
          Washington Accord Knowledge Profiles (WK)
        </h3>
        <b-row>
          <b-col sm="12">
            <div class="table-responsive rounded">
              <table class="table table-striped table-bordered">
                <thead class="thead-dark text-left">
                  <tr>
                    <th>
                      SI. No.
                    </th>
                    <th>
                      Code
                    </th>
                    <th>
                      Outcome
                    </th>
                    <th v-if="!course_id"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(wk, reindex) in wks" :key="reindex">
                    <td>{{ wk.si_no }}</td>
                    <td>
                      {{ wk.code }}
                      <div v-if="(wk.deleted_at != null)">
                        <vue-countdown :time="timeToDeleteIn(wk.deleted_at)" v-slot="{ hours, minutes, seconds }">
                          <b-badge variant="danger" style="white-space: nowrap; margin: 2px;">Delete in
                            {{ hours }}:{{ minutes }}:{{ seconds }}
                          </b-badge><b-link
                            @click="deleteWkModel.id = wk.id; $bvModal.show('cancelDeleteWkConfirmationModel')">
                            <b-badge variant="success">Cancel Deletion</b-badge></b-link>
                        </vue-countdown>
                      </div>
                    </td>
                    <td>{{ wk.outcome }}</td>
                    <td v-if="!course_id">
                      <span class="text-info btn m-0 p-0 sm" size="sm" @click="createEditWk(reindex)"
                        :disabled="actionButton.disabled"><i class="fas fa-pen ml-3"></i></span>
                      <span v-if="(enableDeleteWkButton && wk.deleted_at == null)" :id="'usergroupAdmin' + reIndex"
                        class="btn p-0 m-0 text-info" @click="openDeleteWkModel(wk.id, wk.code)">
                        <i style="color:red;" class="fas fa-trash"></i>
                      </span>

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="resourceaction == 'createEdit'">
        <div v-if="enableImport">
          <h3 style="text-align: center; font-size:18px !important;">
            Import WK From Xcel File
          </h3>
          <img src="../../assets/images/wkExcelImport.jpeg" alt="" style="width: 90%;" class="img-fluid" />
          <p>Fill xcel file with serial number(first column) then WK Name(second column) and Outcome Description(third
            column).</p>
          <b-form-file class="mb-2" v-model="xcelImportFile" :state="Boolean(xcelImportFile)"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv"
            placeholder="Choose an xcel file or drop it here..." drop-placeholder="Drop file here..."
            @change="importWkFromXcel"></b-form-file>
          <div>
            <div v-for="importWk in importWKs" :key="importWk.code" class=" border border-success m-3 p-2">
              <b-row>
                <b-col sm="6">
                  <b-form-group id="input-group-1" label-for="input-1" description="">
                    <label class="required-label" for="">Si. No.:</label>
                    <b-form-input id="input-1" v-model="importWk.si_no" type="text"
                      placeholder="Enter a Number"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group id="input-group-2" label-for="input-2" description="">
                    <label class="required-label" for="">WK Name:</label>
                    <b-form-input id="input-2" v-model="importWk.code" type="text" placeholder="WK 1"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group id="input-group-1" label-for="input-1" description="">
                    <label class="required-label" for="">WK Description:</label>
                    <b-form-textarea v-model="importWk.outcome" placeholder="Description" rows="3"
                      max-rows="6"></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <b-row v-if="(importWKs.length > 0)">
              <b-col sm="12" style="text-align:right;">
                <b-button variant="success" class="text-white sm" size="sm" @click="createImportedWk"
                  :disabled="actionButton.disabled">{{ actionButton.text }}</b-button>
              </b-col>
            </b-row>
          </div>
        </div>
        <div v-else-if="enableWkCopy">
          <h3 style="text-align: center; font-size:18px !important;">
            Copy WK from other Programme
          </h3>
          <b-form-group>
            <label class="required-label" for="">Choose Programme:</label>
            <b-form-select @change="getUsergroupWksForWkCopy" :options="copyWkUsergroups" v-model="copyWkUsergroup_id">
            </b-form-select>
            <span v-if="(copyWkUsergroups.length < 1)" class="text-danger">Loading...</span>
          </b-form-group>
          <ul v-if="copyWkUsergroup_id">
            <span class="text-danger" v-if="(copyFromWkOptions.length < 1)">WK list is empty on selected
              programme</span>

            <li v-for="wkOption in copyFromWkOptions" :key="wkOption.id">
              <b-form-checkbox v-model="copyFromWkIds" name="checkbox-wkcopyoption" :value="wkOption.id">
                {{ wkOption.code }}-{{ wkOption.outcome }}
              </b-form-checkbox>
            </li>
          </ul>
          <b-row>
            <b-col sm="12" style="text-align:right;">
              <b-button variant="success" class="text-white sm" size="sm" @click="submitCopyWk"
                :disabled="(copyFromWkIds.length < 1)">{{ actionButton.text }}</b-button>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <h3 style="text-align: center; font-size:18px !important;">
            {{ wk.id ? 'Edit WK' : 'Add new WK' }}
          </h3>
          <b-row>
            <b-col sm="6">
              <b-form-group id="input-group-1" label-for="input-1" description="">
                <label class="required-label" for="">Si. No.:</label>
                <b-form-input id="input-1" v-model="wk.si_no" type="text" placeholder="Enter a Number"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group id="input-group-2" label-for="input-2" description="">
                <label class="required-label" for="">WK Name:</label>
                <b-form-input id="input-2" v-model="wk.code" type="text" placeholder="WK 1"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="input-group-1" label-for="input-1" description="">
                <label class="required-label" for="">WK Description:</label>
                <b-form-textarea v-model="wk.outcome" placeholder="Description" rows="3" max-rows="6"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { SOFT_DELETE_RETENTION_MINUTES } from "@/constants";
import moment from 'moment';
import VueCountdown from "@chenfengyuan/vue-countdown";
import readXlsxFile from "read-excel-file";
import axios from "axios";
export default {
  props: ['usergroup_id', 'course_id'],
  async created() {
    this.getWks();
  },
  components: {
    VueCountdown,
  },
  data() {
    return {
      otpSent: false,
      otp: "",
      otpVerified: false,
      showOtpBox: false,
      fetchData: false,
      resourceaction: "list", // list,createEdit
      deleteWkModel: { id: null, name: null, confirmText: '', reason: '' },
      wks: [],
      wk: {
        id: null,
        si_no: '',
        code: '',
        outcome: "",
        usergroup_id: '',
      },
      actionButton: {
        text: "Save",
        disabled: false,
      },

      importWKs: [],
      enableImport: false,
      xcelImportFile: null,

      enableWkCopy: false,
      copyWkUsergroups: [],
      copyWkUsergroup_id: null,
      copyFromWkOptions: [],
      copyFromWkIds: [],
      enableDeleteWkButton: true,
      deletedWk: {},
    };
  },
  methods: {
    async sendOtp() {
      if (
        confirm(
          'WARNING: You are going to delete "' +
          this.deleteWkModel.name +
          '". Do you still want to proceed?'
        ) == true
      ) {

        this.showOtpBox = true;
        const url =
          this.$store.getters.getAPIKey.mainAPI + `/wks/send-delete-otp`;

        await this.$axios.post(url, {
          wk_id: this.deleteWkModel.id
        })
          .then(() => {
            // this.$toast.success("OTP sent to your registered email", {
            //   position: "top",
            //   duration: 5000,
            // });
          })
          .catch(() => {
            this.$toast.error("Failed to send OTP", {
              position: "top",
              duration: 5000,
            });
          });
      }
    },

    async verifyOtp() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/wks/verify-delete-otp`;

      await this.$axios.post(url, {
        otp: this.otp,
        wk_id: this.deleteWkModel.id
      })
        .then(() => {
          this.otpVerified = true;
          this.otp = null;
          this.showOtpBox = false;

          this.deleteWk();
        })
        .catch(() => {
          this.$toast.error("Invalid OTP", {
            position: "top",
            duration: 5000,
          });
        });
    },
    async CancelDeletion() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/wks/${this.deleteWkModel.id}/canceldeletion`;
      this.$axios
        .post(url, { reason: this.deleteWkModel.reason })
        .then(() => {
          this.deleteWkModel = { id: null, name: null, confirmText: '', reason: '' };
          this.otp = null;
          this.showOtpBox = false;
          this.getWks();
        });
    },
    timeToDeleteIn(deleted_at) {
      const futureTime = moment.utc(deleted_at, 'YYYY-MM-DD HH:mm:ss').add(SOFT_DELETE_RETENTION_MINUTES, 'minutes');
      const currentUTCTime = moment.utc();
      const timeDifferenceInSeconds = futureTime.diff(currentUTCTime, 'seconds');
      return timeDifferenceInSeconds * 1000;
    },
    deleteWk() {
      let id = this.deleteWkModel.id;
      let name = this.deleteWkModel.name;
      this.enableDeleteWkButton = false;
      this.deletedWk.id = id;
      this.deletedWk.name = name;
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/wks/${id}`;
      this.$axios
        .delete(url, {
          data: { reason: this.deleteWkModel.reason },
        })
        .then(() => {
          this.$toast.success(`${name} deletion initiated successfully`, {
            position: "top-right",
            duration: 6000,
          });
          this.enableDeleteWkButton = true;

          this.deleteWkModel = { id: null, name: null, confirmText: '', reason: '' };
          this.getWks();
        })
        .catch((error) => {
          this.$toast.error(
            `${name} is failed to delete, ` + error.response.data.message,
            {
              position: "top-right",
              duration: 6000,
            }
          );
          error;
          this.enableDeleteWkButton = true;
        });
    },

    openDeleteWkModel(id, name) {
      this.deleteWkModel = { id: id, name: name, confirmText: '', reason: '' };
      this.$bvModal.show("deleteWkConfirmationModel");
    },

    async submitCopyWk() {
      this.fetchData = true;
      this.actionButton = {
        text: "Saving...",
        disabled: true,
      };
      let url = this.$store.getters.getAPIKey.mainAPI + `/wks/copy`;

      await axios.post(url, {
        wks: this.copyFromWkIds,
        copy_to_usergroup: this.usergroup_id,
      })
        .then(() => {
          this.$toast.success("WK copied successfully", {
            position: "top",
            duration: 3000,
          });
          this.getWks();
        })
        .catch(() => {
          let errortxt = "Failed to Copy WK";
          this.$toast.error(errortxt, {
            position: "top",
            duration: 7000,
          });
          return;
        });

      this.fetchData = false;
      this.actionButton = {
        text: "Save",
        disabled: false,
      };
    },
    async getCopyWkOptions() {
      this.copyFromWkOptions = [];
      this.copyFromWkIds = [];
      this.copyWkUsergroups = [];
      this.copyWkUsergroup_id = null;
      this.enableWkCopy = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups?allusergroups=1`;
      await this.$axios
        .get(url)
        .then((response) => {
          response.data.forEach(group => {
            this.copyWkUsergroups.push({
              value: group.id, text: `${group.code}-${group.name}-${group.scheme}-${group.affiliated_university}`
            });
          });
        })
        .catch((error) => {
          error;
        });

      this.actionButton.text = 'Start Copy';
    },

    async getUsergroupWksForWkCopy() {
      this.fetchData = true;
      this.copyFromWkOptions = [];
      this.copyFromWkIds = [];
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/wks?usergroup=${this.copyWkUsergroup_id}`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.copyFromWkOptions = response.data;

          // auto select all WKs from the selected programme
          this.copyFromWkIds = response.data.map(wk => wk.id);
        })
        .catch((error) => {
          error;
        });
      this.fetchData = false;
    },

    async createImportedWk() {
      this.fetchData = true;
      this.actionButton = {
        text: "Saving...",
        disabled: true,
      };
      let url = this.$store.getters.getAPIKey.mainAPI + `/wks`;
      let failedImportWKs = [];
      for (let index = 0; index < this.importWKs.length; index++) {
        const wk = this.importWKs[index];
        await axios.post(url, wk)
          .then(() => {
            this.$toast.success(wk.code + " created successfully", {
              position: "top",
              duration: 3000,
            });
          })
          .catch((error) => {
            failedImportWKs.push(wk);
            let errortxt = "";
            if (error.response)
              if (error.response.status == 422) {
                let errormsgs = error.response.data.errors;
                for (const key in errormsgs) {
                  errortxt = errormsgs[key][0];
                }
              } else {
                errortxt = error.response.data.message;
              }
            else {
              errortxt = "Failed to Update/Create";
            }
            this.$toast.error(errortxt, {
              position: "top",
              duration: 7000,
            });
            return;
          });
      }

      this.fetchData = false;
      this.actionButton = {
        text: "Save",
        disabled: false,
      };
      if (failedImportWKs.length < 1) this.getWks();
      this.importWKs = failedImportWKs;
    },
    async importWkFromXcel(e) {
      if (e.target.files[0] == null) return;

      let error = false;
      let xcelSheet = null;
      await readXlsxFile(e.target.files[0]).then((sheet) => {
        xcelSheet = sheet;
      }).catch(() => {
        this.$toast.error('Failed to process the input xcel file', {
          position: "top",
          duration: 6000,
        });
        error = true;
      });
      if (xcelSheet.length < 1) {
        this.$toast.error('Excel has empty, please fill it.', {
          position: "top",
          duration: 6000,
        });
        error = true;
      }
      if (error) return;
      await xcelSheet.forEach((sheetRow, rowIndex) => {
        if (sheetRow.length != 3) {
          this.$toast.error('Number of column in each row should be 3. Row ' + (rowIndex + 1) + ' has more or less column used', {
            position: "top",
            duration: 6000,
          });
          error = true;
        } else {
          this.importWKs.push({
            si_no: sheetRow[0],
            code: sheetRow[1],
            outcome: sheetRow[2],
            usergroup_id: this.usergroup_id,
          });
        }
      });
      if (this.importWKs.length > 0) this.$toast.warning(this.importWKs.length + ' WKs are imported from excel, please verify and submit', {
        position: "top",
        duration: 6000,
      });
      this.xcelImportFile = null;
    },
    async createEditWk(index) {
      this.enableImport = false;
      this.enableWkCopy = false;
      this.importWKs = [];

      this.wk = {
        id: null,
        si_no: this.wks.length + 1,
        code: '',
        outcome: "",
        usergroup_id: this.usergroup_id,
      };
      if (index !== null) this.wk = this.wks[index];

      this.resourceaction = 'createEdit';
    },
    async getWks() {
      this.fetchData = true;
      this.resourceaction = 'list';
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/wks?usergroup=${this.usergroup_id}`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.wks = response.data;
        })
        .catch((error) => {
          error;
        });
      this.fetchData = false;
    },
    async createUpdateWk() {
      this.fetchData = true;
      this.actionButton = {
        text: "Saving...",
        disabled: true,
      };
      let url = this.$store.getters.getAPIKey.mainAPI + `/wks`;
      let action = 'post';
      if (this.wk.id) {
        url += `/${this.wk.id}`;
        action = 'put';
      }

      await axios[action](url, this.wk)
        .then(() => {
          this.$toast.success("WK created successfully", {
            position: "top",
            duration: 3000,
          });
          this.getWks();
        })
        .catch((error) => {
          let errortxt = "";
          if (error.response)
            if (error.response.status == 422) {
              let errormsgs = error.response.data.errors;
              for (const key in errormsgs) {
                errortxt = errormsgs[key][0];
              }
            } else {
              errortxt = error.response.data.message;
            }
          else {
            errortxt = "Failed to Update/Create";
          }
          this.$toast.error(errortxt, {
            position: "top",
            duration: 7000,
          });
          return;
        });

      this.fetchData = false;
      this.actionButton = {
        text: "Save",
        disabled: false,
      };
    },

  },
};
</script>

<style>
.disable-wrapper.disabled {
  background-color: #e0e0e0;
  /* gray */
  pointer-events: none;
  /* disable all */
  opacity: 0.7;
}

.tag-button button {
  font-size: 9px !important;
  padding: 3px;
}
</style>
